import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton, Title } from '@huggg/react-components';
import styles from './huggg-life.module.scss';
import headerIllustration from 'assets/img/huggg-life/illustration_header.svg';
import footerIllustration from 'assets/img/huggg-life/illustration_footer.svg';

import dictionary from 'config/dictionary';
import config from 'config';

const { hugggLifeBanner: text } = dictionary;

export const HugggLife = ({ url = config.hugggLifeUrl }) => {
  return (
    <div className={styles.container}>
      <img className={styles.headerImage} src={headerIllustration} alt="" />
      <div></div>
      <div className={styles.copy}>
        <Title className={styles.title}>
          {text.action}&nbsp;<strong>{text.item}</strong>
        </Title>
        {text.body.map((line) => (
          <p key={line} className={styles.body}>
            {line}
          </p>
        ))}
      </div>
      <PrimaryButton
        className={styles.button}
        label={text.button}
        onClick={() => {
          window.location.assign(url);
        }}
      />
      <img className={styles.footerImage} src={footerIllustration} alt="" />
    </div>
  );
};

HugggLife.propTypes = {
  url: PropTypes.string,
};
